import * as THREE from 'three'

import { FontLoader } from 'three/examples/jsm/loaders/FontLoader.js'
import { TextGeometry } from 'three/examples/jsm/geometries/TextGeometry.js'
import { FPSController } from '../fpsController'
const canvas = document.querySelector('canvas.webgl')
const clockHtmlElement = document.getElementById('clockHtmlId')

const scene = new THREE.Scene()

const fontLoader = new FontLoader()
let font = null;
fontLoader.load(
    '/fonts/helvetiker_regular.typeface.json',
    (loadedFont) =>
    {
        font = loadedFont;
    })
// const geometry = new THREE.BoxGeometry(1, 1, 1, 2, 2, 2)
// const material = new THREE.MeshBasicMaterial({ color: '#a778d8', wireframe: true })
// const mesh = new THREE.Mesh(geometry, material)
// scene.add(mesh)

const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () =>
{
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 50000)
scene.add(camera)

// Camera presets for each pyramid level: { target Y, radius }
const cameraLevels = [
    { targetY: 6,      radius: 35,   cameraYOffset: 15 },     // milliseconds
    { targetY: -49,    radius: 100,  cameraYOffset: 50 },     // seconds
    { targetY: -193,   radius: 400,  cameraYOffset: 180 },    // minutes
    { targetY: -635,   radius: 1000, cameraYOffset: 480 },    // hours
    { targetY: -2234,  radius: 8000, cameraYOffset: 3500 },   // days
];

let currentLevel = 1; // start on seconds
let targetLevel = 1;
let lerpLevel = 1; // float that smoothly follows targetLevel

function getLevelValues(level) {
    const clamped = Math.max(0, Math.min(cameraLevels.length - 1, level));
    const low = Math.floor(clamped);
    const high = Math.min(low + 1, cameraLevels.length - 1);
    const frac = clamped - low;
    return {
        targetY: cameraLevels[low].targetY + (cameraLevels[high].targetY - cameraLevels[low].targetY) * frac,
        radius: cameraLevels[low].radius + (cameraLevels[high].radius - cameraLevels[low].radius) * frac,
        cameraYOffset: cameraLevels[low].cameraYOffset + (cameraLevels[high].cameraYOffset - cameraLevels[low].cameraYOffset) * frac,
    };
}

let cameraAngle = Math.PI / 4;
const initValues = getLevelValues(currentLevel);
const cameraTarget = new THREE.Vector3(0, initValues.targetY, 0);

camera.position.set(initValues.radius * Math.cos(cameraAngle), initValues.targetY + initValues.cameraYOffset, initValues.radius * Math.sin(cameraAngle));
camera.lookAt(cameraTarget);

canvas.addEventListener('wheel', (e) => {
    e.preventDefault();
    if (e.deltaY > 0) {
        targetLevel = Math.min(targetLevel + 1, cameraLevels.length - 1);
    } else {
        targetLevel = Math.max(targetLevel - 1, 0);
    }
}, { passive: false });

const renderer = new THREE.WebGLRenderer({
    canvas: canvas
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

const ambientLight = new THREE.AmbientLight(0xffffff, 3)
scene.add(ambientLight)

const directionalLight = new THREE.DirectionalLight(0xfbe638, 3)
camera.add(directionalLight)
directionalLight.position.set(0, 200, 0)
directionalLight.target.position.set(0, 0, -1)
camera.add(directionalLight.target)

// const directionalLightHelper = new THREE.DirectionalLightHelper(directionalLight, 0.1)
// scene.add(directionalLightHelper)

const clock = new THREE.Clock()

let oldTextMesh = null;

const englishWeekDays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
const englishMonths = ["January","February","March","April","May","June","July","August","September","October","November","December"];

const spanishWeekDays = ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"]
const spanishMonths = ["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"];

const catalanWeekDays = ["Diumenge", "Dilluns", "Dimarts", "Dimecres", "Dijous", "Divendres", "Dissabte"]
const catalanMonths = ["Gener","Febrer","Març","Abril","Maig","Juny","Juliol","Agost","Setembre","Octubre","Novembre","Desembre"];

function getEnglishDateString(date)
{
    let dayString = "" + date.getDate();
    if(dayString.endsWith("1"))
    {
        dayString += "st"
    }
    else if(dayString.endsWith("2"))
    {
        dayString += "nd";
    }
    else if(dayString.endsWith("3"))
    {
        dayString += "rd"
    }
    else
    {
        dayString += "th"
    }
    return englishWeekDays[date.getDay()] + ", " + englishMonths[date.getMonth()] + " " + dayString + " of " + date.getFullYear();
}

function getSpanishDateString(date)
{
    return spanishWeekDays[date.getDay()] + ", " + date.getDate() + " de " + spanishMonths[date.getMonth()] + " de " + date.getFullYear();
}

function getCatalanDateString(date)
{
    let monthArticle = "de "
    if(date.getMonth() == 3 || date.getMonth == 7)
    {
        monthArticle = "d'"
    }
    return catalanWeekDays[date.getDay()] + ", " + date.getDate() + " " + monthArticle + catalanMonths[date.getMonth()] + " de " + date.getFullYear();
}

function dayOfYear(date) {
    const year = date.getFullYear();
    const startYear = new Date(year, 0, 0);
    const differenceInMillieSeconds = date - startYear;
    return Math.floor(differenceInMillieSeconds / (1000 * 60 * 60 * 24));
};

function drawText()
{
    // if(!font)
    // {
    //     return;
    // }
    // if(oldTextMesh)
    // {
    //     oldTextMesh.removeFromParent();
    // }
    const date = new Date();
    
    let currentDayOfTheYear = dayOfYear(date)
    let currentYearDayLimit = dayOfYear(new Date(""+date.getFullYear()+"-12-31"))
    let dateString = ""+
    getEnglishDateString(date)+
    "<br>"+
    getSpanishDateString(date)+
    "<br>"+
    getCatalanDateString(date)+
    "<br>"+
    date.getFullYear()+
    "/"+
    (date.getMonth()+1)+
    "/"+
    date.getDate()+
    "<br>"+
    "<span style=\"color: #161670\">" + currentDayOfTheYear + "</span>" +"/"+currentYearDayLimit + " day of year" +
    "<br>"+
    "<span style=\"color: #6828c1\">" + date.getHours().toString().padStart(2, '0') + "</span>" +
    ":"+
    "<span style=\"color: #52970b\">" + date.getMinutes().toString().padStart(2, '0') + "</span>" +
    ":"+
    "<span style=\"color: #ffa200\">" + date.getSeconds().toString().padStart(2, '0') + "</span>" +
    "."+
    "<span style=\"color: #fe601c\">" + date.getMilliseconds().toString().padStart(3, '0') + "</span>";

    clockHtmlElement.innerHTML = dateString;

    let currentMiliseconds = date.getMilliseconds();
    let millisecondsLimit = 1000;
    //currentMiliseconds = 1000;
    for(let i=0;i<milisecondMeshes.length; i++)
    {
        if(currentMiliseconds > i)
        {
            milisecondMeshes[i].material = misilecondsVisibleMaterial
        }
        else
        {
            milisecondMeshes[i].material = invisibleMilisecondsMaterial
        }
        milisecondMeshes[i].visible = i < millisecondsLimit
    }

    let currentSeconds = date.getSeconds();
    let secondsLimit = 60;
    //currentSeconds = 60;
    for(let i=0;i<secondMeshes.length; i++)
    {
        if(currentSeconds > i)
        {
            secondMeshes[i].material = secondsVisibleMaterial
        }
        else
        {
            secondMeshes[i].material = invisibleSecondsMaterial
        }
        secondMeshes[i].visible = i < secondsLimit
    }

    let currentMinutes = date.getMinutes();
    //currentMinutes = 60
    for(let i=0;i<minutesMeshes.length; i++)
    {
        if(currentMinutes > i)
        {
            minutesMeshes[i].material = minutesVisibleMaterial
        }
        else
        {
            minutesMeshes[i].material = invisibleMinutesMaterial
        }
        minutesMeshes[i].visible = i < secondsLimit
    }

    let currentHours = date.getHours();
    let hoursLimit = 24
    //currentHours = 24;
    for(let i=0;i<hoursMeshes.length; i++)
    {
        if(currentHours > i)
        {
            hoursMeshes[i].material = hoursVisibleMaterial
        }
        else
        {
            hoursMeshes[i].material = invisibleHoursMaterial
        }
        hoursMeshes[i].visible = i < hoursLimit
    }

    let daysLimit = 366
    //currentHours = 24;
    for(let i=0;i<daysMeshes.length; i++)
    {
        if(currentDayOfTheYear > i)
        {
            daysMeshes[i].material = daysVisibleMaterial
        }
        else
        {
            daysMeshes[i].material = invisibleDaysMaterial
        }
        daysMeshes[i].visible = i < currentYearDayLimit
    }

    // Text
    // const textGeometry = new TextGeometry(
    //     dateString,
    //     {
    //         font: font,
    //         size: 0.2,
    //         depth: 0.1,
    //         curveSegments: 12,
    //         bevelEnabled: false,
    //         bevelThickness: 0.03,
    //         bevelSize: 0.02,
    //         bevelOffset: 0,
    //         bevelSegments: 5
    //     }
    // )
    // // textGeometry.center()

    // const material = new THREE.MeshBasicMaterial({ })

    // oldTextMesh = new THREE.Mesh(textGeometry, material)
    // scene.add(oldTextMesh)
}

const geometry = new THREE.BoxGeometry(1, 1, 1)

let originPoint = null
function sortByDistance(pos1, pos2)
{
    let distance1 = pos1.position.distanceToSquared(originPoint)
    let distance2 = pos2.position.distanceToSquared(originPoint)
    return distance1 - distance2
}

function buildPyramid(desiredItems, array, material, offset,scale)
{
    let total = 0;
    let scaleOffset = scale + scale * 0.4;

    for(let x=0; x<desiredItems; x++)
    {
        for(let y=0; y<desiredItems; y++)
        {
            for(let z=0; z<desiredItems; z++)
            {
                const mesh = new THREE.Mesh(geometry, material)
                mesh.scale.set(scale,scale,scale);
                mesh.position.set( 
                    x * scaleOffset - (desiredItems - 1.0) * 0.5 * scaleOffset, 
                    y * scaleOffset + offset, 
                    z * scaleOffset - (desiredItems - 1.0) * 0.5 * scaleOffset);// - (currentPyramid[0] - 1.0 ) * 0.5 * scaleOffset);
                array.push(mesh)
                scene.add(mesh)
                total++;
            }
        }
    }

    originPoint = new THREE.Vector3(0,-60000,0)
    array.sort(sortByDistance)
}

let useWireframe = false
let milisecondMeshes = []
let misilecondsVisibleMaterial = new THREE.MeshStandardMaterial({ color: 0xfe601c , wireframe: useWireframe, metalness : 0.45, roughness : 0.65});
let secondsVisibleMaterial = new THREE.MeshStandardMaterial({ color: 0xffa200 , wireframe: useWireframe, metalness : 0.45, roughness : 0.65});
let minutesVisibleMaterial = new THREE.MeshStandardMaterial({ color: 0x52970b , wireframe: useWireframe, metalness : 0.45, roughness : 0.65});
let hoursVisibleMaterial = new THREE.MeshStandardMaterial({ color: 0x6828c1 , wireframe: useWireframe, metalness : 0.45, roughness : 0.65});
let daysVisibleMaterial = new THREE.MeshStandardMaterial({ color: 0x161670 , wireframe: useWireframe, metalness : 0.45, roughness : 0.65});

let invisibleMilisecondsMaterial = new THREE.MeshStandardMaterial({ color: 0xfe601c , wireframe: useWireframe, metalness : 0.45, roughness : 0.65, opacity: 0.15, transparent: true})
let invisibleSecondsMaterial = new THREE.MeshStandardMaterial({ color: 0xffa200 , wireframe: useWireframe, metalness : 0.45, roughness : 0.65, opacity: 0.15, transparent: true})
let invisibleMinutesMaterial = new THREE.MeshStandardMaterial({ color: 0x52970b , wireframe: useWireframe, metalness : 0.45, roughness : 0.65, opacity: 0.15, transparent: true})
let invisibleHoursMaterial = new THREE.MeshStandardMaterial({ color: 0x6828c1 , wireframe: useWireframe, metalness : 0.45, roughness : 0.65, opacity: 0.15, transparent: true})
let invisibleDaysMaterial = new THREE.MeshStandardMaterial({ color: 0x161670 , wireframe: useWireframe, metalness : 0.45, roughness : 0.65, opacity: 0.15, transparent: true})

let milisecondSize = 1
buildPyramid(10,milisecondMeshes, misilecondsVisibleMaterial, 0, milisecondSize) //add some extra as the crest of the pyramid might not be reached

let secondsSize = milisecondSize * 1000
let secondMeshes = []
buildPyramid(4,secondMeshes, secondsVisibleMaterial, -70, Math.cbrt(secondsSize))

let minutesSize = secondsSize * 60;
let minutesMeshes = []
buildPyramid(4,minutesMeshes, minutesVisibleMaterial, -275, Math.cbrt(minutesSize))

let hoursSize = minutesSize * 60;
let hoursMeshes = []
buildPyramid(3,hoursMeshes, hoursVisibleMaterial, -850, Math.cbrt(hoursSize))

let daysSize = hoursSize * 24;
let daysMeshes = []
buildPyramid(8,daysMeshes, daysVisibleMaterial, -4400, Math.cbrt(daysSize))
let fpsController = new FPSController();

let angle = 0;

const tick = () =>
{   
    const elapsedTime = clock.getElapsedTime()

    fpsController.tick(elapsedTime);

    drawText();

    angle+=0.005;

    // Oscillate light position slightly relative to camera
    directionalLight.position.x = Math.sin(angle) * 150;
    directionalLight.position.z = Math.cos(angle * 0.7) * 100;

    // Smoothly interpolate between camera levels
    lerpLevel += (targetLevel - lerpLevel) * 0.05;
    const level = getLevelValues(lerpLevel);

    // Rotate camera: 1 full turn per minute, ticks each second with ease
    const now = new Date();
    const t = now.getMilliseconds() / 1000;
    const eased = t * t * (3 - 2 * t); // smoothstep ease
    cameraAngle = (now.getSeconds() + eased) / 60 * Math.PI * 2;
    camera.position.x = level.radius * Math.cos(cameraAngle);
    camera.position.y = level.targetY + level.cameraYOffset;
    camera.position.z = level.radius * Math.sin(cameraAngle);
    cameraTarget.y = level.targetY;
    camera.lookAt(cameraTarget);

    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()